"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Fade_1 = require("./Fade");

exports.Fade = Fade_1.Fade;